import moment from "moment/moment";

const RecentVisits = ({ recentVisits }) => {
  return (
    <div className="card all-cards mt-10 p-0">
      <div className="card-header bg-white py-6">
        <h5 className="mb-0">Recent Visits</h5>
      </div>

      <div className="card-body table-responsive p-4">
        <table
          className="table table-hover  m-0 table-bordered"
          id="commontable"
        >
          <thead className="theadheading">
            <tr>
              <th>Time</th>
              <th>Agent</th>
              <th>Farmer</th>
              <th>Village</th>
              <th>Purpose</th>
            </tr>
          </thead>
       
          <tbody>
            {recentVisits?.length > 0 ? (
              recentVisits.map((visit, index) => (
                <tr key={index}>
                  <td>{moment.utc(visit.visitedAt).local().format("hh:mm A")}</td>
                  <td>{visit.agentName}</td>
                  <td>{visit.farmerName}</td>
                  <td>{visit.villageArea}</td>
                  <td>{visit.purposeOfVisit}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>
                  <p className="m-0 p-3 text-center font-weight-bold">
                    No Data Found
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentVisits;
